
    import './styles.scoped.css';
    export default {
  "marker": "awsui_marker_1kjc7_m0rk7_5",
  "root": "awsui_root_1kjc7_m0rk7_19",
  "title": "awsui_title_1kjc7_m0rk7_32",
  "list": "awsui_list_1kjc7_m0rk7_36",
  "marker--dimmed": "awsui_marker--dimmed_1kjc7_m0rk7_58",
  "marker--highlighted": "awsui_marker--highlighted_1kjc7_m0rk7_61",
  "marker--focused": "awsui_marker--focused_1kjc7_m0rk7_64"
};
  